import api from '@/api';
import router from '@/router';

export default {
  namespaced: true,
  state     : {
    modals: [
      {
        active: false,
        type  : 'add_training',
      },
    ],
  },
  getters: {
    add_training: ({modals}) => modals.find( (modal) => modal.type === 'add_training'),
  },
  mutations: {
    CLOSE_MODAL(state, dialog_type) {
      state.modals.find((modal)=> modal.type === dialog_type).active = false;
    },
    OPEN_MODAL(state, dialog_type) {
      let modal = state.modals.find((modal)=> modal.type === dialog_type);
      if (!modal.active) {
        modal.active = true;
      }
    },
  },
  actions: {
    async get_all_organizations_courses() {
      try {
        let allOrganizationsCourses = await api.tests.get_all_organizations_courses();

        return allOrganizationsCourses.data;
      } catch (err) {
        if (err.message.indexOf('401')!==-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
    async create_assigned_test({commit, dispatch}, obj) {
      console.log(obj);

      try {
        await api.tests.create_assigned_test(obj);

        commit('learning_management/modals/CLOSE_MODAL', 'add_training', {root: true});
        dispatch('learning_management/employees/update_completed_courses', {}, {root: true});
      } catch (err) {
        if (err.message.indexOf('401')!==-1) {
          router.push({name: 'auth'});
          localStorage.clear();
        }
      }
    },
  },
};
